import { useListWorkspacePreferencesQuery } from "../store/api";
import { workspaceEntityTypeDataToEntityTypeMap } from "../store/types";
import { useDashboardFullPathInformations } from "./use-current-dashboard";
export const useListWorkspacePreferences = (entity) => {
    const entityType = workspaceEntityTypeDataToEntityTypeMap(entity.type, entity.subtype);
    const queryResult = useListWorkspacePreferencesQuery({ entityType }, { refetchOnMountOrArgChange: true });
    return {
        isFinished: !queryResult.isLoading,
        isPending: queryResult.isLoading
    };
};
export const useGetCurrentWorkspace = (currentWorkspace, workspacePreferences) => {
    const { selectedWorkspace } = useDashboardFullPathInformations();
    return selectedWorkspace ? workspacePreferences?.find((option) => option.id === selectedWorkspace) : currentWorkspace;
};
export const useDefaultWorkspaceId = (entityType) => {
    const { data: workspacePrefsData } = useListWorkspacePreferencesQuery({ entityType });
    return workspacePrefsData?.workspacePreferences
        .find((wp) => wp.WorkspacePreferences.isDefault)?.Workspace.id;
};
